'use client';

import dynamic from 'next/dynamic';
import React from 'react';
import { DesktopOnly } from './DesktopOnly';

const GalleryDesktopSection = dynamic(
  () => import('./GalleryDesktopSection').then((mod) => mod.GalleryDesktopSection),
  {
    ssr: false,
  },
);

export const DesktopGalleryLoader: React.FC = () => {
  return (
    <DesktopOnly minWidth={1024}>
      <GalleryDesktopSection />
    </DesktopOnly>
  );
};
